export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10892.8b060cb8.jpg";